// @ts-nocheck
import { Column } from 'react-table'
import { UserInfoCell } from './UserInfoCell'
import { User } from '../../core/_models'
import CustomHeader from '../../../components/header/CustomHeader'
import { CreatedAtCell } from '../../../users/table/columns/CreatedAtCell'

// const { auth } = useAuth();
const returnColumns = (navigate: any) => {
  const columns: ReadonlyArray<Column<User>> = [
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Scheme ID' className='min-w-110px' />
      ),
      id: 'couponSchemeId',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={
            <button
              className='p-0 border-0 bg-white text-primary fw-bold'
              onClick={() => {
                const id = props.data[props.row.index]?.couponSchemeId ?? ''
                navigate(`/promotions/schemas/${id}/details`)
              }}
            >
              {props.data[props.row.index]?.couponSchemeId ?? 'N/A'}
            </button>
          }
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Name' className='mw-125px' />
      ),
      id: 'schemeName',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.schemeName ?? 'N/A'}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Status' className='mw-110px' />
      ),
      id: 'schemeStatus',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.schemeStatus ?? 'N/A'}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Start Date' className='mw-125px' />
      ),
      id: 'creationStartDateTime',
      Cell: ({ ...props }) => (
        <CreatedAtCell createdAt={props.data[props.row.index]?.creationStartDateTime} />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='End Date' className='mw-125px' />
      ),
      id: 'creationEndDateTime',
      Cell: ({ ...props }) => (
        <CreatedAtCell createdAt={props.data[props.row.index]?.creationEndDateTime} />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Sponsor' className='mw-125px' />
      ),
      id: 'sponsor',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={props.data[props.row.index]?.sponsor ?? 'N/A'}
        />
      ),
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='Discount Value' className='mw-100px' />
      ),
      id: 'discountValue',
      Cell: ({ ...props }) => (
        <UserInfoCell
          user={props.data[props.row.index]}
          col={`${props.data[props.row.index]?.discountValue}` ?? 'N/A'}
        />
      ),
    }
  ]
  return columns
}

export { returnColumns }
